export default __webpack_public_path__ + "static/media/box-create-community.891ad87f.svg";